// Function index:
//   installCameraControls(canvas, camera, opts) — wire pan-with-middle/right
//       drag + wheel-zoom on a Pixi Container ("camera"). Returns nothing; pure
//       side-effect installer. Caller owns lifecycle (the canvas leaving the
//       DOM stops the listeners from firing further). `opts.onChange` fires
//       after every pan or zoom — Phase B3 viewport-culling uses this to
//       know when to relayout tiles.

import type { Container } from 'pixi.js';

const ZOOM_FACTOR = 1.1;
const MIN_SCALE = 0.3;
const MAX_SCALE = 3;

export interface CameraOptions {
  onChange?: () => void;
}

export function installCameraControls(
  canvas: HTMLCanvasElement,
  camera: Container,
  opts: CameraOptions = {},
): void {
  const notify = (): void => { opts.onChange?.(); };
  let panning = false; let lastX = 0; let lastY = 0;
  canvas.addEventListener('pointerdown', (e) => {
    if (e.button === 2 || e.button === 1) { panning = true; lastX = e.clientX; lastY = e.clientY; }
  });
  window.addEventListener('pointerup', () => { panning = false; });
  window.addEventListener('pointermove', (e) => {
    if (!panning) return;
    camera.x += e.clientX - lastX;
    camera.y += e.clientY - lastY;
    lastX = e.clientX; lastY = e.clientY;
    notify();
  });
  canvas.addEventListener('contextmenu', (e) => e.preventDefault());
  canvas.addEventListener('wheel', (e) => {
    e.preventDefault();
    const factor = e.deltaY < 0 ? ZOOM_FACTOR : 1 / ZOOM_FACTOR;
    camera.scale.x = Math.min(Math.max(camera.scale.x * factor, MIN_SCALE), MAX_SCALE);
    camera.scale.y = camera.scale.x;
    notify();
  }, { passive: false });
}
